import { isFeatureEnabled } from './consent'
import { uuid } from './uuid'

export const REQUEST_ID_HEADER = 'X-Request-Id'

export function newRequestId(): string {
  return uuid()
}

// Header is sent only with the flag on: older gateways reject it in CORS preflight.
export function withRequestId(requestId: string): {
  headers?: Record<string, string>
} {
  if (!isFeatureEnabled()) return {}
  return { headers: { [REQUEST_ID_HEADER]: requestId } }
}
